import { jsx as _jsx } from "react/jsx-runtime";
import { useLoggedUser } from "@jti/loyalty";
import { useSelector } from "@jti/store";
import { PushBlock as PushBlockLib } from "@jti/ui";
export const PushBlock = (props) => {
    const [isLogged] = useLoggedUser();
    const { isRestricted } = useSelector((store) => store.loyaltyCore);
    const { cta, ctaLogged, href, hrefLogged, ctaRestricted, hrefRestricted } = props;
    let buttonText = cta;
    let buttonUrl = href;
    if (ctaLogged && hrefLogged && isLogged) {
        if (ctaRestricted && hrefRestricted && isRestricted) {
            buttonText = ctaRestricted;
            buttonUrl = hrefRestricted;
        }
        else {
            buttonText = ctaLogged;
            buttonUrl = hrefLogged;
        }
    }
    return _jsx(PushBlockLib, { ...props, cta: buttonText, href: buttonUrl, className: "light-theme" });
};
